/**
 * Frontend form field response models for schedule-apply.
 *
 * Matches Android: com.indeed.android.ghostwriter.models.ScheduleApplyFormFieldResponse
 */

export enum ScheduleApplyFormFieldResponseValidationStatus {
  Valid = "valid",
  Invalid = "invalid",
}

export interface ScheduleApplyFormFieldResponseBase {
  formFieldId: string;
  formField: string;
  validationStatus: ScheduleApplyFormFieldResponseValidationStatus;
}

export interface ScheduleApplyUnboundFormFieldResponse extends ScheduleApplyFormFieldResponseBase {
  responseValue: string;
}

export interface ScheduleApplyOptionsFormFieldResponse extends ScheduleApplyFormFieldResponseBase {
  responseValues: string[];
}
